import { render, staticRenderFns } from "./EntryFee.vue?vue&type=template&id=2a647659&"
import script from "./EntryFee.vue?vue&type=script&lang=js&"
export * from "./EntryFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports